/**
 * Editorial state of an article, derived the same way the member API decides
 * visibility: a row is live once `is_published` is set *and* `published_at` has
 * passed. Everything the panel shows about status flows through here so the chip in
 * the list can never disagree with what members actually see.
 */

export type ArticleStatus = "draft" | "scheduled" | "published";

export function articleStatus(
  article: { is_published: boolean; published_at: string },
  now: Date = new Date(),
): ArticleStatus {
  if (!article.is_published) return "draft";
  return new Date(article.published_at) > now ? "scheduled" : "published";
}
